import { Text, View } from '@react-pdf/renderer';
import parse from 'html-react-parser';

const Projects = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.projectsField}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.rightDetails}>
				{data?.length > 0 &&
					data?.map((res: any, index: any) => (
						<View
							key={`prj-t2-${res?.projectTitle}-${index}`}
							style={styles.projectContent}
							wrap={false}
						>
							<View style={styles.listBorder}>
								<View style={styles.listCircle}></View>
							</View>
							<View style={styles.projectContentData}>
								<Text style={styles.detailText}>{res?.projectTitle}</Text>
								{res?.projectDesc && (
									<Text style={styles.detailSubText}>{parse(res.projectDesc)}</Text>
								)}
								<Text style={styles.urlData}>{res?.projectLink}</Text>
							</View>
						</View>
					))}
			</View>
		</View>
	);
};

export default Projects;
